import React, { Component } from "react";
import "../../styles/maps/map.scss";
import { utcToLocal } from "../../utils/dateConvert";
import { offsetMapLocation, drawDepot } from "../../utils/map";
import { here_api_key } from "../../utils/mapapi";
import $ from "jquery";
import { Button } from "react-bootstrap";

const ARROW_MIN_ZOOM_LEVEL = 8;
const ARROW_MAX_ZOOM_LEVEL = 20;

function getMinZoomLevel(index, numPoints) {
  // Start with 10 arrows in min zoom level
  let divider = Math.floor(numPoints / 10);
  for (let i = ARROW_MIN_ZOOM_LEVEL; i <= ARROW_MAX_ZOOM_LEVEL; i += 2) {
    if (index % divider === 0) {
      return i;
    }
    divider = Math.floor(divider / 2);
    if (divider <= 1) {
      break;
    }
  }
  return ARROW_MAX_ZOOM_LEVEL;
}

class VisitMap extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  // Create SVG Flag marker
  createFlagMarker(markerName) {
    return `<svg width="48" height="42" xmlns="http://www.w3.org/2000/svg">
    <g >
     <path d="m7.03553,3.53539q0,1.93944 -1.70025,2.96303l0,34.10183q0,0.35017 -0.25238,0.60608t-0.59775,0.25589l-1.70025,0q-0.34536,0 -0.59775,-0.25589t-0.25238,-0.60608l0,-34.10183q-1.70025,-1.02359 -1.70025,-2.96303q0,-1.42765 0.99624,-2.43777t2.40426,-1.01012t2.40426,1.01012t0.99624,2.43777l0,0l0.00001,0zm39.10578,1.72394l0,20.55268q0,0.67342 -0.33208,1.03706t-1.04937,0.74075q-5.71178,3.12465 -9.80302,3.12465q-1.62056,0 -3.28096,-0.59261t-2.88246,-1.29296t-3.06843,-1.29296t-3.78571,-0.59261q-5.10076,0 -12.32682,3.93276q-0.45162,0.24244 -0.8767,0.24244q-0.69073,0 -1.1955,-0.5118t-0.50477,-1.21216l0,-19.98701q0,-0.86197 0.82357,-1.48152q0.5579,-0.37711 2.09875,-1.15828q6.26968,-3.2324 11.18447,-3.2324q2.84261,0 5.31329,0.78115t5.81805,2.37042q1.00952,0.5118 2.33784,0.5118q1.43458,0 3.12156,-0.56568t2.9223,-1.26603t2.33784,-1.26603t1.44787,-0.56568q0.69073,0 1.1955,0.5118t0.50477,1.21216l0,0l0,0.00002l0.00001,0.00004z" fill="#6AB36A" fill-opacity=".7" />
     <text font-weight="bold" xml:space="preserve"  alignment-baseline="middle" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="16" id="svg_4" y="50%" x="50%" fill-opacity="null" stroke-opacity="null" stroke-width="0" stroke="null" fill="#000000">${markerName}</text>
    </g>
   </svg>`;
  }
  // Create Start pin
  createStartMarker() {
    return `<svg width="40" height="64" version="1.1" viewBox="0 0 10.583 16.933" xmlns="http://www.w3.org/2000/svg">
    <g transform="matrix(1.0608 0 0 1.0608 -1.9236 -.4301)">
      <g transform="matrix(.56129 0 0 .56129 -455.16 -156.95)">
        <path d="m817.11 282.97c-1.2582 1.3428-2.0462 3.2988-2.0156 5.1387 0.0639 3.8448 1.7969 5.3002 4.5684 10.592 0.99832 2.3285 2.0403 4.7924 3.0312 8.873 0.13772 0.60193 0.27203 1.161 0.33416 1.2095 0.0621 0.0485 0.19644-0.51262 0.33416-1.1146 0.99098-4.0807 2.0329-6.5426 3.0312-8.8711 2.7714-5.2916 4.5044-6.747 4.5684-10.592 0.0306-1.8399-0.75942-3.7978-2.0176-5.1406-1.4372-1.5339-3.605-2.6691-5.9162-2.7166s-4.4809 1.0877-5.9181 2.6216z" fill="#70B7CC" fill-opacity=".7" stroke="#000" stroke-width=".28707"/>
        <text x="819.55414" y="292.56235" fill="#ffffff" font-family="sans-serif" font-size="10.056px" stroke-width=".47138" style="font-variant-caps:normal;font-variant-east-asian:normal;font-variant-ligatures:normal;font-variant-numeric:normal;line-height:1.25" xml:space="preserve"><tspan x="819.55414" y="292.56235" fill="#ffffff" font-family="sans-serif" font-size="10.056px" stroke-width=".47138" style="font-variant-caps:normal;font-variant-east-asian:normal;font-variant-ligatures:normal;font-variant-numeric:normal">S</tspan></text>
      </g>
    </g>
  </svg>
  `;
  }
  // Create End pin (Truck)
  createEndMarker() {
    return `<svg width="64" height="64" version="1.1" viewBox="0 0 16.933 16.933" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-107.64 -134.28)">
      <path d="m113.28 147.06q0-0.5003-0.37238-0.8659-0.37238-0.36561-0.88194-0.36561t-0.88193 0.36561q-0.37238 0.3656-0.37238 0.8659t0.37238 0.86589q0.37237 0.36562 0.88193 0.36562t0.88194-0.36562q0.37238-0.36559 0.37238-0.86589zm-3.7629-4.926h3.7629v-2.463h-1.5483q-0.12736 0-0.21558 0.0866l-1.9108 1.8761q-0.0882 0.0866-0.0882 0.21167zm12.543 4.926q0-0.5003-0.37238-0.8659-0.37236-0.36561-0.88192-0.36561-0.50957 0-0.88193 0.36561-0.37238 0.3656-0.37238 0.8659t0.37238 0.86589q0.37236 0.36562 0.88193 0.36562 0.50956 0 0.88192-0.36562 0.37238-0.36559 0.37238-0.86589zm2.5086-10.468v9.852q0 0.14432-0.039 0.25496-0.0394 0.11056-0.13232 0.178-0.0931 0.0674-0.16168 0.11072-0.0686 0.0434-0.23027 0.0578-0.16166 0.0144-0.22049 0.0192-0.0589 5e-3 -0.24987 0-0.19109-5e-3 -0.22048-5e-3 0 1.0198-0.73493 1.7414-0.73496 0.72158-1.7737 0.72158-1.0387 0-1.7737-0.72158-0.73494-0.72159-0.73494-1.7414h-3.7629q0 1.0198-0.73494 1.7414-0.73495 0.72158-1.7737 0.72158-1.0387 0-1.7736-0.72158-0.73494-0.72159-0.73494-1.7414h-0.62716q-0.0293 0-0.22048 5e-3 -0.1911 5e-3 -0.24989 0-0.0589-5e-3 -0.22049-0.0192-0.16166-0.0144-0.23029-0.0578-0.0686-0.0434-0.16164-0.11072-0.0931-0.0674-0.13232-0.178-0.039-0.11072-0.039-0.25496 0-0.25014 0.18617-0.43295 0.18621-0.1828 0.44099-0.1828v-3.0788q0-0.077-5e-3 -0.33673-5e-3 -0.25977 0-0.36561 5e-3 -0.10592 0.0245-0.33192 0.0195-0.22609 0.0637-0.35598 0.0442-0.12992 0.13728-0.29345 0.0931-0.16355 0.22049-0.28862l1.9402-1.905q0.18619-0.1828 0.49488-0.30787 0.30868-0.12512 0.57326-0.12512h1.5679v-1.8473q0-0.25014 0.1862-0.43295 0.18617-0.1828 0.44097-0.1828h10.034q0.2548 0 0.44099 0.1828 0.18617 0.18281 0.18617 0.43295z" fill="#D9534F" fill-opacity=".7" stroke-width=".0097098"/>
    </g>
  </svg>`;
  }
  // Create arrow
  createArrowMarker(angle) {
    return `<svg width="94" height="94" version="1.1" viewBox="0 0 24.871 24.871" xmlns="http://www.w3.org/2000/svg">
    <path transform="rotate(${angle}, 12.4355, 12.4355)" d="m4.705 20.534 7.7304-7.7304 7.7304 7.7304" fill="none" stroke="#1414FF" stroke-linecap="round" stroke-linejoin="round" stroke-opacity=".7" stroke-width="1.4725"/>
    </svg>`;
  }

  componentDidMount() {
    window.handleNext = (data, assetIndex) => {
      let truckIndexInt = parseInt(assetIndex);
      let assetIndexPass;
      if (assetIndex == this.props.subTripPoints.length - 1) {
        assetIndexPass = -1;
      } else {
        assetIndexPass = assetIndex;
      }

      let element;
      let obj = {};
      if (truckIndexInt < this.props.subTripPoints.length - 1) {
        obj = {
          lat: this.props.subTripPoints[truckIndexInt + 1].lat,
          lng: this.props.subTripPoints[truckIndexInt + 1].lng,
        };
        element = this.props.subTripPoints[truckIndexInt + 1];
      } else {
        obj = {
          lat: this.props.subTripPoints[0].lat,
          lng: this.props.subTripPoints[0].lng,
        };
        element = this.props.subTripPoints[0];
      }
      let instruction = `<div style="color:#2296cc;text-transform:uppercase;"><strong>${this.setTripName(
          element.name
        )}</strong></div><div class="bodyContent"><p><span>${
          element.address
        }<br><strong style="color:#55b673;">${
          element.assetName
        }</strong><br><strong>Arrived</strong>: <span>${utcToLocal(
          element.arrived
        )}</span><br><strong>Departed</strong>: <span>${utcToLocal(
          element.departed
        )}</span><br><strong>Parked</strong>: <span>${
          element.parked
        }</span><br><strong>Fridge</strong>: <span>${
          element.fridge
        }</span><br><strong>Temp A</strong>: <span>${
          element.tempA
        }</span><br><strong>Temp B</strong>: <span>${
          element.tempB
        }</span></p></div><div class="info-win-nav not-pop-up"><div class="not-button" onclick="handlePrevious('${
          element.name
        }','${parseInt(assetIndexPass) + 1}')">< ${
          this.setTripNamePre(element.name, parseInt(assetIndexPass) + 1) || ''
        }</div><div class="not-button" onclick="handleNext('${element.name}','${
          parseInt(assetIndexPass) + 1
        }')">${
          this.setTripNameNext(element.name, parseInt(assetIndexPass) + 1) || ''
        } ></div></div>`;

      this.openBubble(obj, instruction);

      window.map.setCenter(offsetMapLocation(window.map, { lat: element.lat, lng: element.lng }, { y: -150 }));
    };

    window.handlePrevious = (data, assetIndex) => {
      let truckIndexInt = parseInt(assetIndex);
      let assetIndexPass;
      if (assetIndex == 0) {
        assetIndexPass = this.props.subTripPoints.length;
      } else {
        assetIndexPass = assetIndex;
      }

      let element;
      let obj = {};
      if (truckIndexInt !== 0) {
        obj = {
          lat: this.props.subTripPoints[truckIndexInt - 1].lat,
          lng: this.props.subTripPoints[truckIndexInt - 1].lng,
        };
        element = this.props.subTripPoints[truckIndexInt - 1];
      } else {
        obj = {
          lat: this.props.subTripPoints[this.props.subTripPoints.length - 1].lat,
          lng: this.props.subTripPoints[this.props.subTripPoints.length - 1].lng,
        };

        element = this.props.subTripPoints[this.props.subTripPoints.length - 1];
      }
      let instruction = `<div style="color:#2296cc;text-transform:uppercase;"><strong>${this.setTripName(
          element.name
        )}</strong></div><div class="bodyContent"><p><span>${
          element.address
        }<br><strong style="color:#55b673;">${
          element.assetName
        }</strong><br><strong>Arrived</strong>: <span>${utcToLocal(
          element.arrived
        )}</span><br><strong>Departed</strong>: <span>${utcToLocal(
          element.departed
        )}</span><br><strong>Parked</strong>: <span>${
          element.parked
        }</span><br><strong>Fridge</strong>: <span>${
          element.fridge
        }</span><br><strong>Temp A</strong>: <span>${
          element.tempA
        }</span><br><strong>Temp B</strong>: <span>${
          element.tempB
        }</span></p></div><div class="info-win-nav not-pop-up"><div class="not-button" onclick="handlePrevious('${
          element.name
        }','${parseInt(assetIndexPass) - 1}')">< ${
          this.setTripNamePre(element.name, parseInt(assetIndexPass) - 1) || ''
        }</div><div  class="not-button" onclick="handleNext('${element.name}','${
          parseInt(assetIndexPass) - 1
        }')">${
          this.setTripNameNext(element.name, parseInt(assetIndexPass) - 1) || ''
        } ></div></div>`;

      this.openBubble(obj, instruction);

      window.map.setCenter(offsetMapLocation(window.map, { lat: element.lat, lng: element.lng }, { y: -100 }));
    };

    // set up containers for the map  + panel
    var mapContainer = document.getElementById("mapContainerVisit");

    //Step 1: initialize communication with the platform
    // In your own code, replace variable window.apikey with your own apikey
    var platform = new window.H.service.Platform({
      apikey: here_api_key,
    });

    let engineType = window.H.Map.EngineType['HARP'];

    var defaultLayers = platform.createDefaultLayers({
      engineType: engineType
    });

    let defaultLayer = defaultLayers.vector.normal.lite;

    //Step 2: initialize a map - this map is centered over Berlin
    let map = new window.H.Map(mapContainer, 
      defaultLayer, {
            engineType: engineType,
      center: { lat: -25.62958, lng: 133.83359 },
      zoom: 4,
      pixelRatio: window.devicePixelRatio || 1,
    });

    // add a resize listener to make sure that the map occupies the whole container
    var viewPort = map.getViewPort();
    viewPort.setPadding(20, 50, 20, 50);

    window.map = map;
    window.addEventListener("resize", () => viewPort.resize());

    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    var mapBehaviour = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));

    var scrollBlock = document.getElementById("mapScrollBlock");

    var ctrlDown = false;
    var checkCtrl = (event) => {
        if (event.key !== 'Control') return;
        if (event.repeat) return;

        ctrlDown = event.type === 'keydown';

        if (ctrlDown) {
            mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
        } else {
            mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
        }
    }

    // Using global events since we want to capture regardless of where you are on the page
    document.addEventListener('keydown', checkCtrl);
    document.addEventListener('keyup', checkCtrl);

    var scrollTimer = null;

    // And HERE captures wheel events at the document level so we have to go to the very highest level to undo their mistakes
    window.addEventListener('wheel', function (event) {
        if (ctrlDown) return;
        if (scrollTimer) clearTimeout(scrollTimer);

        scrollBlock.classList.add('in');
        scrollTimer = setTimeout(() => {
            scrollBlock.classList.remove('in');
            scrollTimer = null;
        }, 30);
    }, {
        capture: true,
        passive: true,
    });

    // Disable wheel zoom by default
    mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);

    // Create the default UI components
    var ui = window.H.ui.UI.createDefault(map, defaultLayers);

    window.ui = ui;
    window.platform = platform;
  }

  componentDidUpdate(prevProps) {
    if (this.props.visitMapPoints !== prevProps.visitMapPoints) {
      window.map.setCenter({
        lat: this.props.visitMapPoints[0].lat,
        lng: this.props.visitMapPoints[0].lng,
      });
      this.calculateRouteFromAtoB(window.platform);
    }

    if (this.props.subTripPoints !== prevProps.subTripPoints) {
      this.addSubTripPoints(this.props.subTripPoints);
    }

    if (this.props.depot !== prevProps.depot) {
      this.drawDepotArea(this.props.depot);
    }
  }

  setTripName = (name) => {
    return `Trip ${name}`;
  };

  setTripNameNext = (name, assetIndex) => {
    let truckIndexInt = parseInt(assetIndex);

    if (truckIndexInt < this.props.subTripPoints.length - 1) {
      let element = this.props.subTripPoints[truckIndexInt + 1];

      return `Trip ${element.name}`;
    } else {
      let element = this.props.subTripPoints[0];

      return `Trip ${element.name}`;
    }
  };

  setTripNamePre = (name, assetIndex) => {
    let truckIndexInt = parseInt(assetIndex);

    if (truckIndexInt !== 0) {
      let element = this.props.subTripPoints[truckIndexInt - 1];

      return `Trip ${element.name}`;
    } else {
      let element = this.props.subTripPoints[
        this.props.subTripPoints.length - 1
      ];

      return `Trip ${element.name}`;
    }
  };

  addSubTripPoints = (data) => {
    window.group = new window.H.map.Group();
    this.props.subTripPoints.forEach((element, assetIndex) => {
      // Create flag icon
      const flagIcon = new window.H.map.Icon(
        this.createFlagMarker(element.name),
        {
          size: { w: 48, h: 42 },
          anchor: { x: 0, y: 42 },
        }
      );
      var marker = new window.H.map.Marker(
        {
          lat: element.lat,
          lng: element.lng,
        },
        { icon: flagIcon }
      );

      window.group.addObject(marker);
      marker.instruction = `<div style="color:#2296cc;text-transform:uppercase;"><strong>${this.setTripName(
          element.name
        )}</strong></div><div class="bodyContent"><p><span>${
          element.address
        }<br><strong style="color:#55b673;">${
          element.assetName
        }</strong><br><strong>Arrived</strong>: <span>${utcToLocal(
          element.arrived
        )}</span><br><strong>Departed</strong>: <span>${utcToLocal(
          element.departed
        )}</span><br><strong>Parked</strong>: <span>${
          element.parked
        }</span><br><strong>Fridge</strong>: <span>${
          element.fridge
        }</span><br><strong>Temp A</strong>: <span>${
          element.tempA
        }</span><br><strong>Temp B</strong>: <span>${
          element.tempB
        }</span></p></div><div class="info-win-nav not-pop-up"><div class="not-button" onclick="handlePrevious('${
          element.name
        }','${assetIndex}')">< ${
          this.setTripNamePre(element.name, assetIndex) || ''
        }</div><div class="not-button"  onclick="handleNext('${
          element.name
        }','${assetIndex}')">${
          this.setTripNameNext(element.name, assetIndex) || ''
        } ></div></div>`;
    });

    window.group.addEventListener("tap", (evt) => {
      window.map.setCenter(offsetMapLocation(window.map, evt.target.getGeometry(), { y: -100 }));
      this.openBubble(evt.target.getGeometry(), evt.target.instruction);
    }, false);

    // Add the maneuvers group to the map
    window.map.addObject(window.group);
  };

  calculateRouteFromAtoB = async (platform) => {
    let point = this.props.visitMapPoints.map((pt) => {
      return {'lat' : pt.lat, 'lng' : pt.lng} ;
    });

    this.drawRoute(point);
    this.drawRouteMarkers();
  };

  /*
   * Draw route using points matched by here maps routing api
   */
  drawRoute = (points) => {
    let lineString = new window.H.geo.LineString();
    let polyline;
    points.forEach((point) => {
      lineString.pushLatLngAlt(point.lat,point.lng);
    });

    polyline = new window.H.map.Polyline(lineString, {
      style: {
        lineWidth: 3,
        strokeColor: "rgba(239, 93, 231, 0.8)",
      },
    });

    // Add the polyline to the map
    window.map.addObject(polyline);

    // And zoom to its bounding rectangle
    window.map.getViewModel().setLookAtData({
      bounds: polyline.getBoundingBox(),
    });
  };

  /**
   * Creates a series of H.map.Marker points from the route and adds them to the map.
   */
  drawRouteMarkers = () => {
    let startIcon = new window.H.map.Icon(this.createStartMarker(), {
      size: { w: 40, h: 64 },
      anchor: { x: 20, y: 64 },
    });
    let endIcon = new window.H.map.Icon(this.createEndMarker(), {
      size: { w: 32, h: 32 },
      anchor: { x: 16, y: 16 },
    });
    window.group = new window.H.map.Group();

    const numPoints = this.props.visitMapPoints.length;
    this.props.visitMapPoints.forEach((element, index) => {
      if (index === 0) {
        // Start marker
        var marker = new window.H.map.Marker(
          {
            lat: element.lat,
            lng: element.lng,
          },
          { icon: startIcon }
        );

        marker.first = true;
        marker.instruction = `<p><span>${
            element.name
          }<br> 7-8 Acorn Ct<br> Dry Creek SA 5094<br> Australia</span><br><strong style="color:#d6af15;">${
            element.assetName
          }</strong><br><strong>Received</strong>: <span>${utcToLocal(
            element.recieved
          )}</span><br><strong>Parked</strong>: <span>${
            element.parked
          }</span><br><strong>Speed</strong>: <span>${
            element.speed
          }</span><br><strong>Fridge</strong>: <span>Off</span><br><strong>Temp A</strong>: <span></span><br><strong>Temp B</strong>: <span></span></p>`;

        window.group.addObject(marker);
      } else if (index === this.props.visitMapPoints.length - 1) {
        let marker = new window.H.map.Marker(
          {
            lat: element.lat,
            lng: element.lng,
          },
          { icon: endIcon }
        );

        window.group.addObject(marker);
      } else {
        // Create arrow
        // Distribute arrows across zoom levels (Arrive at a fraction between 0 and 1. Using sine for distribution)
        const arrowMinZoomLevel = getMinZoomLevel(index, numPoints);
        const arrowIcon = new window.H.map.Icon(
          this.createArrowMarker(element.angle),
          {
            size: { w: 24, h: 24 },
            anchor: { x: 12, y: 12 },
          }
        );
        let marker = new window.H.map.Marker(
          {
            lat: element.lat,
            lng: element.lng,
          },
          { icon: arrowIcon, min: arrowMinZoomLevel }
        );

        window.group.addObject(marker);
      }
    });

    window.group.addEventListener("tap", (evt) => {
      window.map.setCenter(evt.target.getGeometry());
    }, false);

    // Add the maneuvers group to the map
    window.map.addObject(window.group);
  };

  drawDepotArea = (depot) => {
    if (!depot) return;
    drawDepot(window.map, depot);
  }

  bubble;

  openBubble = (position, text) => {
    if (!this.bubble) {
      this.bubble = new window.H.ui.InfoBubble(
        position,
        // The FO property holds the province name.
        { content: text }
      );
      window.ui.addBubble(this.bubble);
    } else {
      this.bubble.setPosition(position);
      this.bubble.setContent(text);
      this.bubble.open();
    }
  };

  onError = (error) => {
    alert("Can't reach the remote server");
  };

  handleFullScreen = () => {
    $("#mapContainerVisit")[0].requestFullscreen();
  };

  render() {
    return (
      <React.Fragment>
        <div className="fullScreenButton">
          <Button onClick={this.handleFullScreen}>
            <i className="fa fa-expand"></i>
          </Button>
        </div>
        <div id="mapContainerVisit" tabIndex="0">
          <div id="mapScrollBlock"></div>
        </div>
      </React.Fragment>
    );
  }
}

export default VisitMap;
